import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import api from "../../utility/api/api.js";
import { pendingAmountAction } from "../../actions/index";
import PendingAmountDetails from "./PendingAmountDetails";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

class PendingAmount extends Component {
  constructor(props) {
    super(props);
    console.log("pendingprops", props);
  }
  componentWillMount() {
    const checkStoreData = api.getpendingAmountResult(this);
  }
  render() {
    console.log(
      "this.pendingData",
      this.props.pendingData && this.props.pendingData
    );
    return (
      <Row>
        {this.props.pendingData ? (
          <Col>
            <PendingAmountDetails trips={this.props.pendingData} />
            {/* <PendingAmountDetails trips={this.state.data.trips} msg={this.state.data.msg}/> */}
          </Col>
        ) : (
          ""
        )}
      </Row>
    );
  }
}
function mapStateToProps(state) {
  console.log("HomePagePending", state);
  return {
    pendingData: state.getpendingamount && state.getpendingamount,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { pendingAmountAction: pendingAmountAction },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(PendingAmount);



// WEBPACK FOOTER //
// ./src/components/Assigned/PendingAmount.js